export function toSnakeCase(e) {
  if(!e.match(/([A-Z])/g)) {
    return e
  }

  return e.match(/([A-Z])/g).reduce(
    (str, c) => str.replace(new RegExp(c), '_' + c.toLowerCase()),
    e
  ).substring((e.slice(0, 1).match(/([A-Z])/g)) ? 1 : 0);
}

export function toCamelCase(s) {
  return s.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}
